<div class="container flex flex-column justify-content-center align-items-center">
    <p-card header="Alterar Senha">
        <ng-template pTemplate="header">
            <app-logo [paramChave]="true" [loadingEmpresa]="false" [logoBase64]="imagemLogoBase64"></app-logo>
        </ng-template>

        <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">

            <div class="field">
                <div class="card flex justify-content-center">
                    <p-password placeholder="Nova senha" [toggleMask]="true" [(ngModel)]="usuario.senhaNova" [weakLabel]="'Fraca'" [mediumLabel]="'Boa'" [strongLabel]="'Forte'" [feedback]="false">
                        <!-- <ng-template pTemplate="header">
                            <h6>Escolha uma senha</h6>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="mt-2">Sugestão</p>
                            <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                <li>Pelo menos uma letra minuscula</li>
                                <li>Pelo menos uma letra maiuscula</li>
                                <li>Pelo menos um número</li>
                                <li>Minimo de 8 caracteres</li>
                            </ul>
                        </ng-template> -->
                    </p-password>
                </div>
            </div>

            <div class="field">
                <div class="card flex justify-content-center">
                    <p-password placeholder="Confirme a senha" [toggleMask]="true" [(ngModel)]="usuario.senhaNovaConfirma" [weakLabel]="'Fraca'" [mediumLabel]="'Boa'" [strongLabel]="'Forte'" [feedback]="false">
                        <!-- <ng-template pTemplate="header">
                            <h6>Escolha uma senha</h6>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="mt-2">Sugestão</p>
                            <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                <li>Pelo menos uma letra minuscula</li>
                                <li>Pelo menos uma letra maiuscula</li>
                                <li>Pelo menos um número</li>
                                <li>Minimo de 8 caracteres</li>
                            </ul>
                        </ng-template> -->
                    </p-password>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">
                <div class="pb-5">
                    <p-button class="btn-bg-primary" label="Atualizar" (click)="atualizarSenha()" [loading]="loading" [disabled]="!usuario.senhaNova || !usuario.senhaNovaConfirma || usuario.senhaNova !== usuario.senhaNovaConfirma || loading === true"></p-button>
                </div>
            </div>
        </ng-template>
    </p-card>
</div>